(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rm-carrusel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rm-photo-marquee')) {
    customElements.define('rm-photo-marquee', class extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('.rm-marquee__viewport');
        this.track = this.querySelector('.rm-marquee__track');
        this.originals = Array.from(this.querySelectorAll('[data-original]'));
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.motion.addEventListener('change', () => this.build(), options);
        document.addEventListener('visibilitychange', () => this.sync(), options);
        this.addEventListener('shopify:block:select', event => {
          const index = this.originals.findIndex(item => item.dataset.blockId === event.detail.blockId);
          this.editing = true;
          this.sync();
          if (index >= 0 && this.animation) this.animation.currentTime = index * this.step / Number(this.dataset.speed) * 1000;
          if (index >= 0 && !this.animation) this.viewport.scrollLeft = index * this.step;
        }, options);
        this.addEventListener('shopify:block:deselect', () => { this.editing = false; this.sync(); }, options);
        this.observer = new ResizeObserver(() => this.build());
        this.observer.observe(this.viewport);
      }
      sync() {
        if (!this.animation) return;
        if (this.editing || document.hidden) this.animation.pause();
        else this.animation.play();
      }
      build() {
        this.animation?.cancel();
        this.animation = null;
        this.track.querySelectorAll('[data-copy]').forEach(item => item.remove());
        this.removeAttribute('data-ready');
        const count = this.originals.length;
        const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
        const width = Math.max(1, (this.viewport.clientWidth - gap * 3) / 4);
        this.style.setProperty('--rm-width', `${width}px`);
        this.step = width + gap;
        if (!count || this.motion.matches || !this.viewport.clientWidth) return;
        const cycleCount = Math.max(count, Math.ceil(4 / count) * count);
        for (let index = count; index < cycleCount * 2; index++) {
          const copy = this.originals[index % count].cloneNode(true);
          copy.removeAttribute('data-original');
          copy.removeAttribute('data-block-id');
          copy.removeAttribute('data-shopify-editor-block');
          copy.setAttribute('data-copy', '');
          copy.setAttribute('aria-hidden', 'true');
          copy.setAttribute('inert', '');
          copy.querySelectorAll('[id]').forEach(element => element.removeAttribute('id'));
          this.track.append(copy);
        }
        const distance = cycleCount * this.step;
        this.viewport.scrollLeft = 0;
        this.setAttribute('data-ready', '');
        this.animation = this.track.animate([
          { transform: 'translateX(0)' },
          { transform: `translateX(-${distance}px)` }
        ], { duration: distance / Number(this.dataset.speed) * 1000, iterations: Infinity, easing: 'linear' });
        this.sync();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.events?.abort();
        this.animation?.cancel();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
